import * as React from 'react';

const SVGCalendar: React.SFC<SvgProps> = props => (
    <svg width={20} height={19} {...props}>
        <path
            d="M13.5 14.5a1.001 1.001 0 010-2 1.001 1.001 0 010 2m0-3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m-7 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2m0-3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m7-2a1.001 1.001 0 010-2 1.001 1.001 0 010 2m0-3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m-7 3a1.001 1.001 0 010-2 1.001 1.001 0 010 2m0-3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m10.937-4.1H17a.6.6 0 100 1.2h.437c.531 0 .963.432.963.963v11.874a.964.964 0 01-.963.963H2.563a.964.964 0 01-.963-.963V4.563c0-.531.432-.963.963-.963H3a.6.6 0 100-1.2h-.437A2.166 2.166 0 00.4 4.563v11.874c0 1.192.97 2.163 2.163 2.163h14.874a2.166 2.166 0 002.163-2.163V4.563c0-1.192-.97-2.163-2.163-2.163M5 5.6a.6.6 0 00.6-.6V1a.6.6 0 10-1.2 0v4a.6.6 0 00.6.6m10 0a.6.6 0 00.6-.6V1a.6.6 0 10-1.2 0v4a.6.6 0 00.6.6m-8-2h6a.6.6 0 100-1.2H7a.6.6 0 100 1.2"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default SVGCalendar;
